import React, { FC } from 'react';
import styles from './popover_loading.module.scss';
import { EntitiesCardBody } from '../../entities-card/EntitiesCardBody';
import { EntitiesCardFooterContainer } from '../../entities-card/EntitiesCardFooter';

type Props = {
  width?: string;
  height?: string;
};

export const Loader: FC<Props> = ({ width = '100%', height = '40px' }) => (
  <div className={styles.loader} style={{ width, height }} />
);

export const PopoverLoading: FC = () => (
  <div className={styles.container}>
    <EntitiesCardBody>
      <Loader />
    </EntitiesCardBody>
    <EntitiesCardFooterContainer>
      <Loader width="50%" />
    </EntitiesCardFooterContainer>
  </div>
);
